import '../style.css';
import Library from '../lib/Library.js';
import {Map} from '../lib/Map.js';
import {BaseLayer} from '../lib/BaseLayer.js';
import {MapLayer} from '../lib/MapLayer.js';
import {RadarLayer} from '../lib/layers/Radar.js';
import {SatelliteLayer} from '../lib/layers/Satellite.js';
import {SigmetLayer} from '../lib/layers/Sigmet.js';
import {CwaLayer} from '../lib/layers/Cwa.js';
import {MousePosition} from '../lib/controls/MousePosition.js';
import {ScaleLine} from '../lib/controls/ScaleLine.js';
import {DateLabel} from '../lib/controls/DateLabel.js';

let cur_date = Library.getDate();
console.info( cur_date );

function init(){
    let map = new Map();
    map.addLayer( new BaseLayer( map, {"type": "globe_light"} ));
    map.addLayer( new SatelliteLayer( map, {"type": "sat_ir"} ));
    map.addLayer( new RadarLayer( map, {"type": "rad_win"} ));
    map.addLayer( new MapLayer( map, {"type": "basic"}, {"visible": true } ));
    map.addLayer( new MapLayer( map, {"type": "county"} ));
    map.addLayer( new MapLayer( map, {"type": "highway"} ));
    map.addLayer( new MapLayer( map, {"type": "jetroute"} ));
    map.addLayer( new MapLayer( map, {"type": "fir"} ));
    map.addLayer( new SigmetLayer( map, {}, {"visible": true} ));
    map.addLayer( new CwaLayer( map, {}, {"visible": true} ));
    map.addControl( new MousePosition( map ));
    map.addControl( new ScaleLine( map ));
    map.addControl( new DateLabel( map ));
    map.setupInput();
    map.setLocation();
    map.setTimeout();

    window.map = map;
}

document.addEventListener("DOMContentLoaded", function() {
    init();
});
